import React from 'react';
import gql from 'graphql-tag';
import { Field } from 'formik';
import { useLazyQuery } from '@apollo/client';
import { CustomSelectComponent, FieldSelectDB, FsProps } from 'motion-components';
import { useTranslation } from 'react-i18next';

const gqlGetGroups = gql`
  query getCntItemGroupOptions($where: String, $offset: Int, $limit: Int, $order: String) {
    getCntItemGroups(where: $where, offset: $offset, limit: $limit, order: $order) {
      data {
        id
        description: name
      }
      recordCount
    }
  }
`;

const gqlGetSubgroups = gql`
  query getCntItemSubgroupOptions($where: String, $offset: Int, $limit: Int, $order: String) {
    getCntItemSubgroups(where: $where, offset: $offset, limit: $limit, order: $order) {
      data {
        id
        description: name
      }
      recordCount
    }
  }
`;

function useGetItemGroupsQuery() {
  return useLazyQuery(gqlGetGroups);
}

function useGetItemSubgroupsQuery() {
  return useLazyQuery(gqlGetSubgroups);
}

export const FieldSelectItemGroups = ({
  label = 'Ομάδα',
  name = 'groupId',
  sbLabel = '',
  ...rest
}: FsProps & { sbLabel?: string }) => {
  return (
    <FieldSelectDB
      {...rest}
      label={label}
      name={name}
      sbLabel={sbLabel}
      hook={useGetItemGroupsQuery}
    />
  );
};

/** Υποομάδες της επιλεγμένης ομάδας. Το where το δίνει η φόρμα. */
export const FieldSelectItemSubgroups = ({
  label = 'Υποομάδα',
  name = 'subgroupId',
  where = '',
  sbLabel = '',
  ...rest
}: FsProps & { sbLabel?: string }) => {
  return (
    <FieldSelectDB
      {...rest}
      label={label}
      name={name}
      where={where}
      sbLabel={sbLabel}
      hook={useGetItemSubgroupsQuery}
    />
  );
};

/** 1 τεμάχιο, 2 κιλό, 3 τεμάχιο × Ah — ίδιες τιμές με τη δήλωση εισφοράς */
export const FieldSelectPriceCalculationMethod = ({
  label,
  name = 'priceCalculationMethod',
  disabled = false,
}: {
  label: string;
  name?: string;
  disabled?: boolean;
}) => {
  const { t } = useTranslation();
  const options = [
    { value: 1, label: t('Εισφορά ανά Τεμάχιο') },
    { value: 2, label: t('Εισφορά ανά Κιλό') },
    { value: 3, label: t('Εισφορά ανά Τεμάχιο × Ah') },
  ];

  // Το component βάζει μόνο του FormCol, όπως τα υπόλοιπα πεδία της γραμμής
  return (
    <Field
      name={name}
      title={label}
      component={CustomSelectComponent}
      options={options}
      disabled={disabled}
    />
  );
};
